import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function SecuredIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.99H19C18.47 16.11 15.72 19.78 12 20.93V12H5V6.3L12 3.19V11.99Z" />
    </IconWrapper>
  );
}
